import "./error.css"
import {setupPlayer} from "../setup-player";
import {createVideoElement, videoUrl} from "../video-js";
import {checkIsLive, checkIsOffLine} from "../server-state";

const retrySchema = [
    { seconds: 10, times: 6 },
    { seconds: 60, times: 10 },
    { seconds: 600, times: Infinity }
]

export function setupErrorScreen(containerElement, settings) {
    containerElement.innerHTML = ''

    let keepRetrying = true

    const errorContainer = document.createElement("div")
    errorContainer.className = `mg-error-container`

    const errorImage = document.createElement("img")
    errorImage.src = settings.errorImage
    errorImage.className = 'mg-error-image'
    errorContainer.appendChild(errorImage)

    if (settings.showErrorMessage) {
        const errorMessage = document.createElement("p")
        errorMessage.className = "mg-error-message"
        errorMessage.innerText = "De stream is momenteel niet beschikbaar"
        errorContainer.appendChild(errorMessage)
    }

    containerElement.appendChild(errorContainer)

    const stopOnlineCheck = checkIsLive(settings, function() {
        stopOnlineCheck()

        // Stream takes a while to boot
        const delay = 4000
        setTimeout(() => {
            setupPlayer(containerElement, settings)
        }, delay)

    }, retrySchema)
}
